import { FireTile } from "../../components/dashboard/FireTile.js";
import { ShockinglySimpleMathTable } from "../../components/dashboard/ShockinglySimpleMathTable.js";
import { SuggestedPromptsTile } from "../../components/SuggestedPromptsTile.js";
import { PAGE_PROMPTS } from "../../lib/data/page-prompts.js";
import { useDocumentTitle } from "../../lib/util/use-document-title.js";
import { FireSubPageLayout } from "./_layout.js";
import { useFireContext } from "./_use-fire-context.js";

/**
 * /fire/numbers — Phase 13.5 extraction from /dashboard#fire.
 *
 * The five FIRE numbers (Lean / Coast / Barista / Regular / Fat) plus
 * Shockingly Simple Math at trailing-12 saving rate.
 */
export function FireNumbersPage() {
  useDocumentTitle("FIRE — Numbers");
  const { hideValues, fiAssetsCents, byAccountType } = useFireContext();
  return (
    <FireSubPageLayout
      title="Your FIRE numbers"
      sub="The five FI thresholds, plus the Shockingly Simple Math table that shows years-to-FI as a function of saving rate."
    >
      <FireTile
        hideValues={hideValues}
        fiAssetsCents={fiAssetsCents}
        byAccountType={byAccountType}
      />
      <ShockinglySimpleMathTable />
      <SuggestedPromptsTile prompts={PAGE_PROMPTS.fireNumbers} />
    </FireSubPageLayout>
  );
}
